const initTabs = () => {
  const tabs = document.querySelectorAll('._tabs');

  for (let index = 0; index < tabs.length; index++) {
    const tab = tabs[index];
    const tabsItems = tab.querySelectorAll('._tabs-item:not([data-prevent-animation="y"])');
    const tabsBlocks = tab.querySelectorAll('._tabs-block');

    for (let secondIdx = 0; secondIdx < tabsItems.length; secondIdx++) {
      const tabsItem = tabsItems[secondIdx];

      tabsItem.addEventListener('click', (e) => {
        for (let thirdIdx = 0; thirdIdx < tabsItems.length; thirdIdx++) {
          const item = tabsItems[thirdIdx];

          item.classList.remove('_open');
          tabsBlocks[thirdIdx].classList.remove('_open');
        }

        tabsItem.classList.add('_open');
        tabsBlocks[secondIdx].classList.add('_open');

        e.preventDefault();
      });
    }
  }

  const tabsSubmenu = document.querySelectorAll('._tabs-submenu');
  for (let index = 0; index < tabsSubmenu.length; index++) {
    const tabSubmenu = tabsSubmenu[index];
    const tabsSubmenuItems = tabSubmenu.querySelectorAll('._tabs-item');
    const tabsSubmenuBlocks = tabSubmenu.querySelectorAll('._tabs-block');
    for (let secondIdx = 0; secondIdx < tabsSubmenuItems.length; secondIdx++) {
      const tabsSubmenuItem = tabsSubmenuItems[secondIdx];
      tabsSubmenuItem.addEventListener('mouseenter', (e) => {
        for (let thirdIdx = 0; thirdIdx < tabsSubmenuItems.length; thirdIdx++) {
          const submenuItem = tabsSubmenuItems[thirdIdx];
          submenuItem.classList.remove('_active');
          tabsSubmenuBlocks[thirdIdx].classList.remove('_active');
        }
        tabsSubmenuItem.classList.add('_active');
        tabsSubmenuBlocks[secondIdx].classList.add('_active');
        e.preventDefault();
      });
    }
  }
};

initTabs();

const initTabCharacteristics = () => {
  const tabsCharacteristics = document.querySelectorAll('.tabs-characteristics');
  for (let index = 0; index < tabsCharacteristics.length; index++) {
    const tab = tabsCharacteristics[index];
    const tabsCharacteristicsItems = tab.querySelectorAll('.tabs-characteristics__item');
    const tabsCharacteristicsBlocks = tab.querySelectorAll('.tabs-characteristics__block');
    for (let secondIdx = 0; secondIdx < tabsCharacteristicsItems.length; secondIdx++) {
      const tabsCharacteristicsItem = tabsCharacteristicsItems[secondIdx];
      tabsCharacteristicsItem.addEventListener('click', (e) => {
        for (let thirdIdx = 0; thirdIdx < tabsCharacteristicsItems.length; thirdIdx++) {
          const characteristicsItem = tabsCharacteristicsItems[thirdIdx];
          characteristicsItem.classList.remove('_open');
          tabsCharacteristicsBlocks[thirdIdx].classList.remove('_open');
        }
        tabsCharacteristicsItem.classList.add('_open');
        tabsCharacteristicsBlocks[secondIdx].classList.add('_open');
        e.preventDefault();
      });
    }
  }
};

initTabCharacteristics();

window.initTabs = initTabs;
window.initTabCharacteristics = initTabCharacteristics;
